export default {
  height: 'calc(var(--n-option-height) * 7.6)',
  paddingTiny: '4px 0',
  paddingSmall: '4px 0',
  paddingMedium: '4px 0',
  paddingLarge: '4px 0',
  paddingHuge: '4px 0',
  optionPaddingTiny: '0 12px',
  optionPaddingSmall: '0 12px',
  optionPaddingMedium: '0 12px',
  optionPaddingLarge: '0 12px',
  optionPaddingHuge: '0 12px',
  loadingSize: '18px'
}
